// File: Captcha.js
import React, { useEffect, useRef } from 'react';

const Captcha = ({ onCodeGenerated, refreshTrigger }) => {
    const canvasRef = useRef(null);

    const generateCaptcha = () => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // 1. Background
        ctx.fillStyle = '#f8f9fa';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // 2. Random Characters
        // 'I', 'l', '1', '0', 'O' hata diye hain taake confusion na ho
        const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789'; 
        let generatedCode = '';

        for (let i = 0; i < 6; i++) {
            const char = chars[Math.floor(Math.random() * chars.length)];
            generatedCode += char;

            const x = 20 + i * 25;
            const y = 30 + Math.random() * 10;
            const angle = (Math.random() - 0.5) * 0.4;

            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(angle);
            ctx.font = 'bold 28px Arial';
            // Random Color for text
            ctx.fillStyle = `rgb(${Math.floor(Math.random()*100)}, ${Math.floor(Math.random()*100)}, ${Math.floor(Math.random()*100)})`;
            ctx.fillText(char, 0, 0);
            ctx.restore();
        }

        // 3. Noise Lines (Security)
        for (let i = 0; i < 5; i++) {
            ctx.beginPath();
            ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
            ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
            ctx.strokeStyle = 'rgba(0,0,0,0.2)';
            ctx.stroke();
        }

        // Code Parent component ko bhejo
        onCodeGenerated(generatedCode);
    };

    // Jab bhi refreshTrigger change ho, naya captcha banao
    useEffect(() => {
        generateCaptcha();
    }, [refreshTrigger]);

    return (
        <canvas 
            ref={canvasRef} 
            width="180" 
            height="50" 
            className="border rounded shadow-sm"
            style={{ cursor: 'pointer' }}
            onClick={generateCaptcha}
            title="Click to Refresh Image"
        />
    );
};

export default Captcha;